// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"41d8c51b","328":"55a8e278","416":"24110e4c","561":"0cafc2c1","676":"4da3d788","882":"742ae721","886":"a3520296"}[chunkId] + ".chunk.js";
};